import { render } from "./Top.vue?vue&type=template&id=674eecbc"
import script from "./Top.vue?vue&type=script&lang=js"
export * from "./Top.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/Top.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "674eecbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('674eecbc', __exports__)) {
    api.reload('674eecbc', __exports__)
  }
  
  module.hot.accept("./Top.vue?vue&type=template&id=674eecbc", () => {
    api.rerender('674eecbc', render)
  })

}


export default __exports__